import { OnInit, Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

/**
 * Component displayed when user lacks access to a protected resource
 * Shows access denied message and optional return link
 */
@Component({
  selector: "no-access",
  templateUrl: "./no-access.component.html",
})
export class NoAccessComponent implements OnInit {
  returnUrl: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    // Get return URL from query params if available
    this.route.queryParams.subscribe(params => {
      this.returnUrl = params['returnUrl'] || null;
    });
  }

  /**
   * Navigate back to the page user tried to access
   */
  goBack(): void {
    if (this.returnUrl) {
      this.router.navigateByUrl(this.returnUrl);
    } else {
      this.router.navigate(['/']);
    }
  }

  /**
   * Navigate to home page
   */
  goHome(): void {
    this.router.navigate(['/']);
  }
}
